import type { QuoteDocument, OptionsDocument } from 'paintscout'
import type { UpdateableProduct } from '../../area-substrates'
import type { RenderableItem } from '../../items'
import type { QuoteItemSection } from '../..'
import { getItems } from '../../items'

/**
 * Get all products from items, so they can be converted into new line items
 */
export function getConversionProducts({
  quote,
  options,
  items,
  view,
  section
}: {
  quote: QuoteDocument
  options: OptionsDocument
  items: RenderableItem[]
  view: 'area' | 'substrate'
  section: QuoteItemSection
}): UpdateableProduct[] {
  const products = items.reduce((acc, item) => {
    if (['area', 'line_item', 'substrate'].includes(item.type)) {
      acc = [...acc, ...(item?.products ?? [])]
    }
    if (item.type === 'group') {
      const groupItems = getItems({
        quote,
        options,
        view,
        keys: quote.groups[item.key].children,
        section,
        consumer: 'customer',
        trimBySubstrateSection: section,
        showGroups: true
      })

      acc = [...acc, ...getConversionProducts({ quote, options, view, section, items: groupItems })]
    }
    return acc
  }, [])

  return products
}
